<div class="page-container">
  <div class="top-toolbar">
    <div class="sub-title">LOAD ANALYSIS</div>
  </div>
  <div class="load-analysis">
    <div class="title">Load Analysis</div>
  </div>
  <h1>Page Under Construction</h1>
</div>
